<div class="layout-container">
  
  <header class="game-header">
    <a class="icon-button" routerLink="/">
      <img src="assets/arrow_back.svg" alt="Back" />
    </a>

    <h1 class="game-title">Mind <span>Link</span></h1>
    <p class="game-subtitle">Enter a room, pick a role and play!</p>
  </header>

  <main class="main-content">

      <app-room-setup
        (connectionCallback)="initializeListeners()"
        (roomIdListener)="setRoomId($event)"
      />

      @if (room_id()){

        @if (is_current_player_selected()){

          <div class="waiting-state">
            <div class="loader"></div>
            <p class="waiting-text">Waiting for teammates...</p>
          </div>

        }
        
        @else {

          <div class="role-selection">

            <button class="role-button primary" [disabled]="is_leader_selected()" (click)="selectPlayer(true)">
              <div class="role-info">
                <span class="role-name">Leader</span>
                <span class="role-desc">Guesses the hidden word</span>
              </div>
            </button>
            
            <button class="role-button secondary" [disabled]="is_prompter_selected()" (click)="selectPlayer(false)">
              <div class="role-info">
                <span class="role-name">Prompter</span>
                <span class="role-desc">Suggests the word</span>
              </div>
            </button>

          </div>

        }
      
      }

  </main>

  <footer class="game-footer">
    <p class="copyright">© 2026 Ludico. All rights reserved.</p>
    <p class="info-links">
      <a routerLink="/mind-link/about" [queryParams]="{ room: room_id() }">About</a>
    </p>
  </footer>

</div>
